import { useEffect, useState } from 'react'
import { api } from '../api'
import type { Locale } from '../i18n'

export function ApiStatus({ locale }: { locale: Locale }) {
  const [state, setState] = useState<'checking' | 'ready' | 'unavailable'>('checking')
  useEffect(() => {
    let alive = true
    let request: AbortController | null = null
    const refresh = async () => {
      if (!alive || request) return
      const controller = new AbortController()
      request = controller
      const timeout = setTimeout(() => controller.abort(), 8000)
      try {
        const health = await api<{ ready: boolean }>('/health/ready', { signal: controller.signal, cache: 'no-store' })
        if (alive) setState(health.ready ? 'ready' : 'unavailable')
      } catch { if (alive) setState('unavailable') }
      finally { clearTimeout(timeout); request = null }
    }
    queueMicrotask(() => void refresh())
    const timer = setInterval(() => void refresh(), 30_000)
    return () => { alive = false; clearInterval(timer); request?.abort() }
  }, [])
  const text = locale === 'en'
    ? { checking: 'Checking API', ready: 'API operational', unavailable: 'API connection unavailable' }
    : { checking: '正在检查 API', ready: 'API 运行正常', unavailable: 'API 连接异常' }
  return <div className={`top-status api-status-${state}`} role="status"><span className="live-dot" />{text[state]}</div>
}
